import { takeLatest, takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services"
import config from '../config/config.json';


function* category(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/product_type/' : config.credentials.url + '/product_type/' + actions.query
        const response = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "CATEGORY_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "CATEGORY_RESPONSE", value: error })
    }
}

function* categories(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/product_type/?offset=0&limit=' + actions.limit : config.credentials.url + '/product_type/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "CATEGORIES_RESPONSE_LIST", value: response })

    } catch (error) {
        yield put({ type: "CATEGORIES_RESPONSE_LIST", value: error })
    }
}

function* add(actions) {

    try {

        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'POST', config.credentials.url + '/product_type/', requestOptions);



        yield put({ type: "CATEGORY_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "CATEGORY_RESPONSE", value: error })
    }
}

function* remove(actions) {

    try {

        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };


        const response = yield call(apiCall, 'delete', config.credentials.url + '/product_type/' + actions.data + '/', requestOptions)


        yield put({ type: "CATEGORY_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "CATEGORY_RESPONSE", value: error })
    }
}

function* edit(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'put', config.credentials.url + '/product_type/' + actions.id + '/', requestOptions)

        yield put({ type: "CATEGORY_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "CATEGORY_RESPONSE", value: error })
    }
}

function* getListProductsLine(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/product_line/?offset=0&limit=' + actions.limit : config.credentials.url + '/product_line/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions)
        response.view = 'list'

        yield put({ type: "PRODUCTS_LINE_LIST_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "PRODUCTS_LINE_LIST_RESPONSE", value: error })
    }
}

function* productLine(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };
        
        let url = (actions.query === null) ? config.credentials.url + '/product_line/' : config.credentials.url + '/product_line/' + actions.query
        
        const response = yield call(apiCall, 'get', url, requestOptions)
       // console.log('response')
        yield put({ type: "PRODUCT_LINE_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "PRODUCT_LINE_RESPONSE", value: error })
    }
}

function* addProductLineAction(actions) {

    try {

        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };
         
        const response = yield call(apiCall, 'POST',config.credentials.url+'/product_line/', requestOptions);

      

        yield put({ type: "PRODUCT_LINE_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "PRODUCT_LINE_RESPONSE", value: error })
    }
}

function* removeProductLineAction(actions) {

    try {

        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
 
        const requestOptions = {
            headers: headers
        };
 

        const response = yield call(apiCall, 'delete', config.credentials.url+ '/product_line/' + actions.data+ '/', requestOptions)


        yield put({ type: "PRODUCT_LINE_RESPONSE", value: response})
 
    } catch (error) {
        yield put({ type: "PRODUCT_LINE_RESPONSE", value: error })
    }
}

function* editProductLineAction(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
 
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };
        
        const response = yield call(apiCall, 'put', config.credentials.url+ '/product_line/' + actions.id+ '/', requestOptions)

        yield put({ type: "PRODUCT_LINE_RESPONSE", value: response})
        
    } catch (error) {
        yield put({ type: "PRODUCT_LINE_RESPONSE", value: error })
    }
}


export function* getCategory() {
    yield takeEvery("GET_CATEGORY", category)
}
export function* getCategoriesList() {
    yield takeEvery("GET_CATEGORIES", categories)
}

export function* addCategory() {
    yield takeEvery("ADD_CATEGORY", add)
}

export function* removeCategory() {
    yield takeEvery("REMOVE_CATEGORY", remove)
}

export function* editCategory() {
    yield takeEvery("EDIT_CATEGORY", edit)
}

export function* getProductsLine() {
    yield takeEvery("GET_PRODUCTS_LINE", getListProductsLine)
}

export function* getProductLine() {
    yield takeEvery("GET_PRODUCT_LINE", productLine)
}

export function* addProductLine() {
    yield takeEvery("ADD_PRODUCT_LINE", addProductLineAction)
}

export function* removeProductLine() {
    yield takeEvery("REMOVE_PRODUCT_LINE", removeProductLineAction)
}

export function* editProductLine() {
    yield takeEvery("EDIT_PRODUCT_LINE", editProductLineAction)
}

